import React, { useState, useEffect, Suspense, lazy } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import { verifyTokenAsync } from '../../../redux/asyncActions/authAsyncActions';
import { BottomNav, Sidebar, LazyLoader } from '../../index';
import NotFound from '../NotFound';
import Dashboard from './Dashboard';
import Profile from './Profile';

function AlertApp({ props }) {
  let role = null;

  const dispatch = useDispatch();
  const authObj = useSelector((state) => state.auth);
  const { isAuthenticated, user, token, expiredAt, superAdmin } = authObj;

  const [openMenu, setOpenMenu] = useState(false);

  const toggleMenu = (value) => {
    setOpenMenu(value);
  };

  return (
    <div className='dashboard'>
      <Sidebar menu={openMenu} closeSidebar={toggleMenu} />

      <Routes>
        <Route
          path='/'
          title='HealthCarePlatform: Dashboard'
          element={<Dashboard />}
        />
        <Route path='/profile' element={<Profile />} />

        <Route
          path='*'
          title='HealthCarePlatform: 404 NOT FOUND'
          element={<Dashboard />}
        />
      </Routes>

      <BottomNav openSideBar={toggleMenu} />
    </div>
  );
}
export default AlertApp;